<template>
  <v-container class="grey lighten-5">
    <div class="pa-3 display-1">
      担当者
    </div>
    <v-card v-if= "!isAdmin" flat outlined class="ma-5 pa-3">
      <div class="subtitle-2 mb-2">
        <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
        <span class="primary--text">担当者管理機能について</span>
      </div>
      <p class="caption">
          担当者管理機能は、管理者権限をお持ちの方のみご利用いただけます。<br>
          この機能をご利用になりたい場合は、事業所の管理者様にご連絡してください。<br>
      </p>
    </v-card>
    <v-card v-else>   
    <v-card-title class="title px-3">登録済み担当者一覧</v-card-title> 
    <v-row class="mx-3 mt-2" dense>               
      <v-col cols="12"  lg="12" md='12' sm='12' xs="12">
        <v-select v-model="OfficeID" label="事業所を選択してください"
          :items="officeList"
          item-value="OfficeID"
          item-text="Name"
          @change="changeOffice"
          filled
        >
          <template slot='selection' slot-scope='data'>
            {{ data.item.CompanyName }} {{ data.item.Name }}
          </template>
          <template slot="item" slot-scope="data">
            <!-- HTML that describe how select should render items when the select is open -->
            {{ data.item.CompanyName }} {{ data.item.Name }}
          </template>
        </v-select>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <div class="px-3">
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          placeholder="担当者を検索"
          filled
        ></v-text-field>
        </div>
      </v-col>
    </v-row>



    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="employees"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :search="search"
          :sort-by="['Name']"
          :sort-desc="[false]"
          class="elevation-1"
          loading-text="読込中"
          no-data-text="データがありません。"                    
          no-results-text="検索条件に該当するデータがありません。"                  
          hide-default-footer
          @page-count="pageCount = $event"
          @click:row="(data) => { $router.push(`/employee?id=${data.id}`) }"
        >
          <template v-slot:[`item.EmployeeID`]="{ item }">
            {{ formatEmployeeID(item.EmployeeID) }}
          </template>
          <template v-slot:[`item.Permission`]="{ item }">
                <v-chip :color="getColor(item.Permission)" dark small>{{ getPermission(item.Permission) }}</v-chip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="10" md='10' sm='12'>
        <v-pagination
          v-model="page"
          :total-visible="totalVisible"
          :length="pageCount"
          color="amber black--text"
          light 
          circle
        >
        </v-pagination>
      </v-col>
      <!-- <v-col cols="2" md='2' sm='4'>
        <v-text-field
          :value="itemsPerPage"
          label="1ページの行数"
          @input="itemsPerPage = $event"
        ></v-text-field>
      </v-col> -->
      <v-col cols="2"  lg="2"  md='2' sm='4' xs="2">
        <v-select
          :value="itemsPerPage"
          :items = "itemsPerPageList"
          label="1ページの行数"
          @input="itemsPerPage = $event"
        ></v-select>
      </v-col>
    </v-row>
  </v-card >    

  </v-container>
</template>


<script>
import { API, graphqlOperation } from "aws-amplify"
import { employeeByOffice } from "../graphql/queries"
//import { companyByKey } from "../graphql/queries"

export default {
  name: 'Employee',
  head: {
    title: { inner: '担当者'},
  },
  data: () => ({
    search: '',
    page: 1,
    pageCount: 0,
    totalVisible: 7,
    itemsPerPage: 10,
    itemsPerPageList: [ 5,10,30 ],
    headers: [
      {
        text: '担当者ＩＤ',
        align: 'start',
        value: 'EmployeeID',
        class: "grey darken-2 white--text"
      },
      {
        text: '担当者名',
        value: 'Name',
        class: "grey darken-2 white--text"
      },
      {
        text: '所属',
        value: 'DeptName',
        class: "grey darken-2 white--text"
      },
      {
        text: '役職',
        value: 'Position',
        class: "grey darken-2 white--text"
      },
      {
        text: 'email',
        value: 'email',
        class: "grey darken-2 white--text"
      },
      {
        text: '権限',
        value: 'Permission',
        class: "grey darken-2 white--text"
      },
    ],
    employees: [],
    OfficeID: "",
    message: "",
  }),
  computed: {
    officeList () {
      return this.$store.state.officeList
    },
    isAdmin () {
      return this.$store.state.isAdmin
    }
  },
  methods: {
    changeOffice: async function () {
      let employees = await API.graphql(graphqlOperation(employeeByOffice, {OfficeID: this.OfficeID, limit: 999}))
      let _employees = employees.data.employeeByOffice.items;

      // システム管理者以外は、WEBの利用許可済みの担当者情報のみに絞り込み
      if(!this.$store.state.isSystemAdmin) {
          this.employees = _employees.filter(function(item, index){ // eslint-disable-line no-unused-vars
            if (!item.Permission.startsWith('0')) return true;
          });
      }else {
        this.employees = _employees
      }

    },
    getColor (Permission) {
      if (Permission == "00000001") return 'gray'  // 未許可
      else if (Permission == "10000000") return 'gray'  // 選択可
      else if (Permission == "10000001") return 'green' // 一般
      else if (Permission == "10000009") return 'amber' //事業所管理者
      else if (Permission == "99999990") return 'pink' //システム管理者（一般スタッフ）
      else if (Permission == "99999999") return 'red' //システム管理者（スーパーユーザー）
      else if (Permission == "77777777") return 'purple' //開発者
      else return 'gray' // その他（あり得ない）
    },
    getPermission (Permission) {
      if (Permission == "00000001") return '未許可'
      else if (Permission == "10000000") return '選択可'
      else if (Permission == "10000001") return '一般'
      else if (Permission == "10000009") return '管理者'
      else if (Permission == "99999990") return 'シス管'
      else if (Permission == "99999999") return 'スーパー'
      else if (Permission == "77777777") return '開発者'
      else return '－'
    },
    formatEmployeeID (employeeID) {
      if (!employeeID || employeeID.length !== 25) return employeeID
      return `${employeeID.slice(0, 10)}-${employeeID.slice(10, 15)}-${employeeID.slice(15, 25)}`
    }
  },
  mounted: async function () {
    //システム管理者権限を持っている場合のみ表示を許可
    if(this.$store.state.isAdmin) {
      this.OfficeID = this.$store.state.myoffice.OfficeID
      let employees = await API.graphql(graphqlOperation(employeeByOffice, {OfficeID: this.$store.state.myoffice.OfficeID}))
      this.employees = employees.data.employeeByOffice.items;
    }
  },
}
</script>
